<template>
    <div
        class="p-6 shadow-2xl rounded-2xl bg-gradient-to-tr from-primary to-secondary"
    >
        <form @submit.prevent="submitForm">
            <div class="mb-4">
                <label for="type" class="block font-bold text-white">
                    Fahrzeugtyp
                </label>
                <div class="relative mt-1 rounded-md shadow-sm">
                    <select
                        v-model="form.type"
                        name="type"
                        id="type"
                        class="block w-full border-white rounded-md"
                    >
                        <option value="truck">Transporter</option>
                        <option value="car">Pkw</option>
                        <option value="oldtimer">Oldtimer</option>
                    </select>
                </div>
            </div>

            <div class="mb-4">
                <label for="start_date" class="block font-bold text-white">
                    Abholdatum
                </label>
                <div class="relative mt-1 rounded-md shadow-sm">
                    <Datepicker
                        v-model="form.start_date"
                        :transitions="false"
                        :inputClassName="
                            form.errors.start_date
                                ? '!border-2 !border-red-500 !rounded-md !h-[42px]'
                                : '!border-0 !h-[42px]'
                        "
                        :enableTimePicker="false"
                        auto-apply
                        locale="de"
                        format="dd.MM.yyyy"
                        placeholder="Datum auswählen"
                        :minDate="new Date()"
                        :disabledDates="disabledDates"
                        @internalModelChange="startDateChanged"
                    ></Datepicker>
                </div>
                <small class="text-white" v-if="form.errors.start_date">
                    <strong>{{ form.errors.start_date }}</strong>
                </small>
            </div>

            <div class="mb-4">
                <label for="start_time" class="block font-bold text-white">
                    Abholzeit
                </label>
                <div class="relative mt-1 rounded-md shadow-sm">
                    <div
                        class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none"
                    >
                        <ClockIcon
                            class="w-5 h-5 text-gray-400"
                            aria-hidden="true"
                        />
                    </div>
                    <input
                        type="time"
                        v-model="form.start_time"
                        name="start_time"
                        id="start_time"
                        :class="[
                            'block w-full pl-9 rounded-md border-0',
                            {
                                '!border-2 border-red-500':
                                    form.errors.start_time,
                            },
                        ]"
                    />
                </div>
                <small class="text-white" v-if="form.errors.start_time">
                    <strong>{{ form.errors.start_time }}</strong>
                </small>
            </div>

            <div class="mb-4">
                <label for="end_date" class="block font-bold text-white">
                    Rückgabedatum
                </label>
                <div class="relative mt-1 rounded-md shadow-sm">
                    <Datepicker
                        v-model="form.end_date"
                        :transitions="false"
                        :inputClassName="
                            form.errors.end_date
                                ? '!border-2 !border-red-500 !rounded-md !h-[42px] placeholder-gray-600'
                                : '!border-0 !h-[42px] placeholder-gray-600'
                        "
                        :enableTimePicker="false"
                        auto-apply
                        locale="de"
                        format="dd.MM.yyyy"
                        placeholder="Datum auswählen"
                        :minDate="form.start_date || new Date()"
                        :disabledDates="disabledDates"
                    ></Datepicker>
                </div>
                <small class="text-white" v-if="form.errors.end_date">
                    <strong>{{ form.errors.end_date }}</strong>
                </small>
            </div>

            <div class="mb-4">
                <label for="end_time" class="block font-bold text-white">
                    Rückgabezeit
                </label>
                <div class="relative mt-1 rounded-md shadow-sm">
                    <div
                        class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none"
                    >
                        <ClockIcon
                            class="w-5 h-5 text-gray-400"
                            aria-hidden="true"
                        />
                    </div>
                    <input
                        type="time"
                        v-model="form.end_time"
                        name="end_time"
                        id="end_time"
                        :class="[
                            'block w-full pl-9 rounded-md border-0',
                            {
                                '!border-2 border-red-500':
                                    form.errors.end_time,
                            },
                        ]"
                    />
                </div>
                <small class="text-white" v-if="form.errors.end_time">
                    <strong>{{ form.errors.end_time }}</strong>
                </small>
            </div>

            <div class="flex justify-end">
                <button type="submit">
                    <StyledButton background-white>
                        Fahrzeug finden
                        <ArrowRightIcon class="w-5 h-5 ml-2" />
                    </StyledButton>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import { Link } from "@inertiajs/inertia-vue3";
import StyledButton from "@/Components/StyledButton.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ClockIcon, ArrowRightIcon } from "@heroicons/vue/outline";

export default {
    components: {
        StyledButton,
        Link,
        Datepicker,
        ClockIcon,
        ArrowRightIcon,
    },

    data() {
        return {
            form: this.$inertia.form({
                type: "truck",
                start_date: this.tomorrow(),
                start_time: "10:00",
                end_date: this.tomorrow(),
                end_time: "18:00",
            }),
        };
    },

    methods: {
        disabledDates(date) {
            return date.getDay() === 0;
        },

        tomorrow() {
            const today = new Date();
            let tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);

            return tomorrow;
        },

        startDateChanged() {
            this.form.end_date = this.form.start_date;
        },

        submitForm() {
            this.form
                .transform((data) => ({
                    ...data,
                    start_date: new Date(data.start_date).toLocaleDateString(
                        "de-DE",
                        {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        }
                    ),

                    end_date: new Date(data.end_date).toLocaleDateString(
                        "de-DE",
                        {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        }
                    ),
                }))
                .post(route("checkout.step.datetime"));
        },
    },
};
</script>
